import { render, staticRenderFns } from "./packageList.vue?vue&type=template&id=dc0fc5ee&scoped=true&"
import script from "./packageList.vue?vue&type=script&lang=js&"
export * from "./packageList.vue?vue&type=script&lang=js&"
import style0 from "./packageList.vue?vue&type=style&index=0&id=dc0fc5ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0fc5ee",
  null
  
)

export default component.exports